import { useTrackedWalletConnect } from '@/features/analytics'
import { cn } from '@/ui/utils/style'
import { cva } from 'class-variance-authority'
import { PropsWithChildren } from 'react'

export const navWalletButtonStyles = cva(
  'group flex min-h-9 min-w-36 items-center justify-center gap-2 rounded-sm border border-white/5 bg-card px-4 py-2 text-sm shadow-md transition-colors hover:bg-muted',
)

interface ConnectButtonProps extends PropsWithChildren {
  className?: string
  source?: string
}

export function ConnectButton({ className, children, source = 'unknown' }: ConnectButtonProps) {
  const connectWallet = useTrackedWalletConnect(source)

  return (
    <button className={cn(navWalletButtonStyles(), className)} onClick={connectWallet}>
      {children}
    </button>
  )
}
